<template>
	<v-container>

		<CargaInicial v-if="$root.dominios.cargando || $root.sitios.cargando"></CargaInicial>

		<v-row justify="center" v-else-if="$root.sitios.listado.length === 0 && $root.dominios.listado.length === 0">
      <v-col
        cols="12"
        sm="6"
				md="4"
				lg="3"
      >
				<v-card class="text-center grey--text text--darken-3">
					<h1 class="mt-4">
						<span style="text-wrap: nowrap;">
							<v-icon class="mr-4">mdi-toolbox</v-icon> <v-icon class="ml-4">mdi-tools</v-icon>
						</span>
					</h1>
					<h2 class="font-weight-regular mb-4">¡Empieza a crear tu primer sitio web!</h2>
					<v-divider class="mx-4"></v-divider>
					<v-card-subtitle><v-icon color="amber">mdi-lightbulb-on-outline</v-icon> Pulsa el botón de abajo a la derecha para empezar a crear tu primer sitio web</v-card-subtitle>
				</v-card>
      </v-col>
    </v-row>

		<div style="width:100%" v-else>
			<v-row class="grey--text text--darken-3">
				<v-col cols="12">
					<h2 class="font-weight-light mt-6">Dominios:</h2>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6" md="4" lg="3" v-for="(dominio, i) in $root.dominios.listado" :key="`dominio${i}`">
					<v-hover v-slot:default="{ hover }">
						<v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" color="#385F73" dark :to="`dominios/${dominio.identificador}/constructor`" append>
							<v-card-title class="headline">{{ dominio.identificador }}</v-card-title>
							<v-divider class="mx-4"></v-divider>
							<v-card-text v-if="!dominio.datos.sitio">Sitio no configurado. Pulsa para empezar.</v-card-text>
							<v-card-subtitle>Pulsa para acceder a la configuración.</v-card-subtitle>
						</v-card>
					</v-hover>
				</v-col>
				<v-col cols="12" sm="6" md="4" lg="3" height="50px">
					<v-hover v-slot:default="{ hover }">
						<v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" class="text-center" height="100%" @click="agregarDominio.agregando = true">
							<v-row align="center" style="height: 100%">
								<v-col cols="12">
									<h2 class="font-weight-regular"><v-icon class="mr-4" color="amber" large>mdi-plus</v-icon> Agregar un dominio</h2>
								</v-col>
							</v-row>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
			<v-row class="grey--text text--darken-3">
				<v-col cols="12">
					<h2 class="font-weight-light">Sitios:</h2>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6" md="4" lg="3" v-for="(sitio, i) in $root.sitios.listado" :key="`sitio${i}`" height="50px">
					<v-hover v-slot:default="{ hover }">
						<v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" color="teal" dark :to="`sitios/${sitio.identificador}/constructor`" height="100%">
							<v-card-title class="headline">Sitio #{{ i+1 }}</v-card-title>
							<v-divider class="mx-4"></v-divider>
							<v-card-text>
								<p><strong>Identificador:</strong> {{ sitio.identificador }}</p>
								<p><strong>Secciones:</strong> {{ sitio.datos.página_principal.secciones.length }}</p>
							</v-card-text>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</div>

		<!-- Empieza diálogo para agregar dominio -->
		<v-dialog
      v-model="agregarDominio.agregando"
			persistent
      max-width="700"
    >
      <v-card>
        <v-card-title class="headline">Agrega un nuevo sitio web</v-card-title>

				<v-card-text>
          <p>Elige el nombre de dominio que quieres usar, por ejemplo «muebles-decorativos.com»:</p>
					<p class="text--red">[ERROR]</p>
        </v-card-text>

        <!--<v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text>

				<v-card-text>
					<v-radio-group v-model="agregarDominio.modo" mandatory>
						<v-radio label="Radio 1" value="radio-1" on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">bla bla bla gg</v-radio>
						<v-radio label="Radio 2" value="radio-2" on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank"></v-radio>
					</v-radio-group>
				</v-card-text>

				<v-card-text>
					<v-list three-line>
						<v-subheader
							tttv-if="item.header"
							ttt:key="item.header"
							v-text="'holaaaaa'"
						></v-subheader>

						<v-divider
							ooooov-else-if="item.divider"
							ooooo:key="index"
							ooooo:inset="item.inset"
						></v-divider>

						<v-list-item
							ooooov-else
							ooooo:key="item.title"
							ooooo_click=""
						>
							<v-list-item-avatar>
								<v-img ssssrc=""></v-img>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title vvvv-html="'Tengo mi'">Ya tengo un nombre de dominio y quiero transferirlo</v-list-item-title>
								<v-list-item-subtitle vvvv-html="'un subtítulo'">Elije esta opción si ya tienes un nombre de dominio, como «<em>muebles-decorativos.com</em>», registrado con otro proveedor y quieres transferirlo con nosotros.</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-list-item
							ooooov-else
							ooooo:key="item.title"
							ooooo_click=""
						>
							<v-list-item-avatar>
								<v-img ssssrc=""></v-img>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title vvvv-html="'un titulo'">
									Ya tengo un nombre de dominio, pero no quiero transferirlo
								</v-list-item-title>
								<v-list-item-subtitle vvvv-html="'un subtítulo'">
									Elije esta opción si ya tienes un nombre de dominio, como «<em>muebles-decorativos.com.co</em>», registrado con otro proveedor y quieres mantenerlo con ese proveedor.
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>

						<v-list-item
							ooooov-else
							ooooo:key="item.title"
							ooooo_click=""
						>
							<v-list-item-avatar>
								<v-img ssssrc=""></v-img>
							</v-list-item-avatar>


							<v-list-item-content>
								<v-list-item-title vvvv-html="'un titulo'">
									Quiero registrar un nombre de dominio nuevo
								</v-list-item-title>
								<v-list-item-subtitle vvvv-html="'un subtítulo'">
									Elije esta opción si quieres registrar y tener tu propio nombre de dominio, como «<em>muebles-decorativos.com.co</em>».
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card-text>-->

        <v-card-actions>
          <v-spacer></v-spacer>

          <!--<v-btn
            color="green darken-1"
            text
            @click="agregarDominio.agregando = false"
          >
            Disagree
          </v-btn>-->

          <v-btn
            color="green darken-1"
            text
            @click="agregarDominio.agregando = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
		<!-- Termina diálogo para agregar dominio -->

		<v-btn
			v-if="$root.sitios.listado.length === 0 && $root.dominios.listado.length === 0 && !$root.dominios.cargando && !$root.sitios.cargando"
      bottom
      color="pink"
      dark
      fab
      fixed
      right
      @click="agregarDominio.agregando = true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

	</v-container>
</template>

<script>

import CargaInicial from '@/views/CargaInicial';

export default {
	data: () => ({
		agregarDominio: {
			agregando: false,
			modo: '',
		}
	}),
	components: {
		CargaInicial
	}	
}

</script>